import React from 'react';


const data = [
  { id: 1, date: "2023-24", heading: 'Waste Management ', profileurl: 'https://static.muoninfotech.com/./assets/IQAC/WASTE MANAGEMENT.pdf' },
];

const WasteManagement = () => {
  return (
    <div className="container">
      {data.map((item) => (
        <div key={item.id} className="card my-3">
          <div className="card-body">
            <div className="row">
              <div className="col-md-3">
                <p>Year : {item.date}</p>
              </div>
              <div className="col-md-6">
                <h3>{item.heading}</h3>
              </div>
              <div className="col-md-3">
                <button className="btn btn-primary" type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = item.profileurl;
                  }}>Download</button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WasteManagement;

